
import {contactwindowDetails } from "../../models/model";
import { ContactWindowActions } from "../interface/reducerType";

import {Types} from '../action/action';

const initialState=  {
  
  isContactWindow:false,
  contactWindowDetails:{},
  isMySpace:false,
  contactSavedChatList:[],
  isContactSavedChat:false,
  contactLinkList:[],
  scrollContactLinkList:[],
  isContactLink:false,
  isSaveChatLoad:false,
  contactSavedLength:0,
  isStopPagination:true,
  isNoteUpdate:false,
  isLinkChatLoad:false,
  contactLinkLength:0,
  isLinkPaginationStop:true,
  contactFileList:[],
  isContactFile:false,
  loadSavedchats:false,
  loadLinks:false,
  isfileLoad:false,
  contactfileLength:0,
  isfileStopPagination:true,
  presenceUserStatus:[],
  isKey:"",
  isWindowSlide:false,
  editData:{},
  isTaskUpdate:false,
  isEventUpdate:false,
  isviewContactFile:false,
  contactFileData:{}
 
};



export const contactWindowReducer = (state: contactwindowDetails = initialState, action: ContactWindowActions) => {
  switch (action.type) {
  case Types.OPEN_CONTACT_WINDOW:
    return {
      ...state, isContactWindow: action.payload.isContactWindow,
      contactWindowDetails: action.payload.contactWindowDetails, 
      isContactSavedChat: false, isContactLink: false
    };

  case Types.CONTACT_SAVED_LIST:
    return {
      ...state, contactSavedChatList: action.payload.contactSavedChatList, isContactSavedChat: true, isSaveChatLoad:false
    };
  case Types.CONTACT_FILES_LIST:
    return {
      ...state, contactFileList: action.payload.contactFileList, isContactFile: action.payload.isContactFile
    };
  case Types.CONTACT_SAVED_LOAD:
    return {
      ...state, isSaveChatLoad: action.payload.isSaveChatLoad,
      contactSavedLength: action.payload.contactSavedLength,
      isStopPagination:action.payload.isStopPagination
    };
  case Types.CONTACT_FILE_LOAD:
    return {
      ...state, isfileLoad: action.payload.isfileLoad,
      contactfileLength: action.payload.contactfileLength,
      isfileStopPagination:action.payload.isfileStopPagination
    };
    
  case Types.CONTACT_LINK_LIST:
    return {
      ...state, contactLinkList: action.payload.contactLinkList, isContactLink: true
    };

  case Types.SCROLL_CONTACT_LINK_LIST:
  return {
      ...state, scrollContactLinkList: action.payload.scrollContactLinkList
  }

  case Types.CONTACT_LINK_LOAD:
    return {
      ...state, isLinkChatLoad: action.payload.isLinkChatLoad,
      contactLinkLength: action.payload.contactLinkLength,
      isLinkPaginationStop:action.payload.isLinkPaginationStop
    };
    
  case Types.CONTACT_NOTE_UPDATE:
    return {
      ...state, isNoteUpdate: action.payload.isNoteUpdate
    };
  case Types.LOADER_SAVED:
    return {
      ...state, loadSavedchats: action.payload.loadSavedchats
    };
  case Types.LOADER_LINKS:
    return {
      ...state, loadLinks: action.payload.loadLinks
    };
    case Types.PRESENCE_USER_STATUS:
      return {
        ...state, presenceUserStatus: action.payload.presenceUserStatus
      };
  case Types.CONTACT_WINDOW_SLIDE_OPEN:
    return {
      ...state, isWindowSlide: action.payload.isWindowSlide,isKey:action.payload.isKey,editData:action.payload.editData
    }; 
  case Types.CONTACT_TASK_UPDATE:
    return {
      ...state, isTaskUpdate: action.payload.isTaskUpdate
    };
  case Types.CONTACT_EVENT_UPDATE:
    return {
      ...state, isEventUpdate: action.payload.isEventUpdate
    };
    case Types.FILE_CHAT_MESSAGE:
      return{
        ...state, isviewContactFile:action.payload.isviewContactFile,
        contactFileData:action.payload.contactFileData
      };
  default:
    return state;
  }
};